module.exports = __webpack_public_path__ + "img/computer_noNetwork.1a6ae35d.svg";